import React, { useEffect } from "react";

import { Backtotop, Floatinmenu,AI_tools } from "../../widgets";
import "../Library/AI_bots.css";
import { RadialMenu,} from "../../components";
import {
  AItoolsmenu,
  aiToolsData,
  
} from "../../constants/library";
import { FaMicrochip } from "react-icons/fa";

export default function AI_bots() {
    useEffect(() => {
        document.title = "ACCET-Library | AI Tools";
    }, []);

    return (
        <>
            <div className="librarypage">
                <div className="librarybg">
                    <div className="libraryheading">Library</div>
                    <div className="library_sub_heading">AI - Tools</div>
                </div>
            </div>
            
            <div className="tools-wrapper">
                
                <section className="librarydark">
                    <div className="dept_float_menu">
                        <Floatinmenu logo={FaMicrochip} head="Menu" links={AItoolsmenu} />
                    </div>
                    <RadialMenu menu_links={AItoolsmenu} />

                </section>
                
                {aiToolsData.map((tool) => (
                    <AI_tools key={tool.id} tool={tool} />
                ))}

            </div>
            <Backtotop />
        </>
    );
}
